import {executeCrudEpic, Type} from 'lib/crud'
import {dao, name} from 'lib/schoolType'
import {combineEpics} from 'redux-observable'

export const schoolTypeEpics = combineEpics(
    executeCrudEpic(name, Type.LIST)(dao.list),
    executeCrudEpic(name, Type.GET)(dao.get),
)